import styles from './Assessment.module.css';
export function AssessmentLoader() {
    return <div className={styles.loader_section}>
        <div className={`${styles.work_hard} textcenter mt50`}>
            <h2 className="text333 font30 fontsm20 mb50 fontMedium">
                Healthy doesn’t have to be hard. We make it easy.
            </h2>
            <div className={styles.loader_logo}>
                <img src="/assets/images/assessment-loader.gif" alt="logo loader" className="img-fluid" />
            </div>
        </div>
    </div>
}